module.exports = __webpack_public_path__ + "img/title5.b28cc8ca.png";